import { inject, Injectable } from '@angular/core';
import { AuthService, DismissedPopupKeywords } from '@isophi/core-legacy';
import { TranslocoService } from '@jsverse/transloco';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { filter, take } from 'rxjs';

import { InnitialPopupComponent } from '../../shared/components/innitial-popup/innitial-popup.component';
import { KindergartenService } from './kindergarten.service';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private readonly modalService = inject(NgbModal);

  private readonly authService = inject(AuthService);

  private readonly translocoService = inject(TranslocoService);

  private readonly kindergartenService = inject(KindergartenService);

  private readonly openedPopups: Partial<Record<DismissedPopupKeywords, NgbModalRef>> = {};

  tryShowPopup(popupKeyword: DismissedPopupKeywords) {
    // Monkey check if translations are loaded or not
    // TODO make it less monkey
    const checkKey = 'diagnostics/popup/title';
    if (this.translocoService.translate(checkKey) !== checkKey) {
      this.showPopup(popupKeyword);
    }

    this.translocoService.events$.pipe(take(1)).subscribe(() => {
      this.showPopup(popupKeyword);
    });
  }

  private showPopup(popupKeyword: DismissedPopupKeywords) {
    const defaultModalConf: NgbModalOptions = {
      size: 'lg',
    };

    this.authService.loggedUser$
      .pipe(
        filter((user) => !!user),
        take(1)
      )
      .subscribe((user) => {
        if (
          user.teacher.dismissedPopupKeywords.some((dismissed) => dismissed === popupKeyword) ||
          !!this.openedPopups[popupKeyword] ||
          this.kindergartenService.loggedKindergarten.isDemo
        ) {
          return false;
        }

        switch (popupKeyword) {
          case 't_app_initial':
            if (this.kindergartenService.loggedKindergarten.isCZKindergarten()) {
              this.openedPopups[popupKeyword] = this.modalService.open(InnitialPopupComponent, defaultModalConf);
              this.openedPopups[popupKeyword].componentInstance.popupKey = popupKeyword;
              return true;
            }
            return false;
          default:
            return false;
        }
      });
  }

  /** Dismiss popup from ever showing again */
  dismissPopup(popUpKey: DismissedPopupKeywords) {
    this.kindergartenService.dismissTeacherPopup(popUpKey);
  }

  closePopup(popupKeyword: DismissedPopupKeywords, onDestroy = false) {
    const previouslyOpened = this.openedPopups[popupKeyword];
    if (previouslyOpened) {
      if (!onDestroy) {
        previouslyOpened.close();
      }
    }
    delete this.openedPopups[popupKeyword];
  }
}
